import React, { useState, useEffect } from "react";
import LeftNavMenu from "./LeftNavMenu";
import getJsonFromApi from "../Common/getJsonFromApi";
import { getMenuNameByPath } from "../Common/LeftNavService";

export default function FrameLeftNav(props) {

  const [leftNav, setLeftNav] = useState([]);
  const [error, setError] = useState(null);
  const { insideRouter, initLayout } = props;
  
  const menuName = window.adminPortalMenu;
  const submenuName = window.adminPortalSubMenu;

  const [menu, setMenu] = useState(menuName);
  const [submenu, setSubmenu] = useState(submenuName);

  const setMenuByPath = (adminPortalLeftNav) => {
    const { menuName } = getMenuNameByPath(adminPortalLeftNav, window.location.pathname);
    if(menuName) {
      setMenu(menuName);
    }
  };

  const setSubmenuByPath = (adminPortalLeftNav) => {
    const { submenuName } = getMenuNameByPath(adminPortalLeftNav, window.location.pathname);
    if(submenuName){
      setSubmenu(submenuName);
    }
  };  

  const initAnimation = () =>{
    // This must be called after div.page-sidebar is rendered for the
    // jQuery-based Metronic expanding/collapsing menus to work
    if (window.Layout) {
      window.Layout.handleFixedSidebar();
    }
    if (initLayout && window.Layout) {
      window.Layout.init();
    }    
  }

  const initLeftNav = (leftNavObject) => {
    checkSelectedMenuAndSubmenu(leftNavObject);
    setLeftNav(leftNavObject);
    initAnimation();
  }

  const checkSelectedMenuAndSubmenu = (leftNavObject) =>{
    const menuName = window.adminPortalMenu;
    const submenuName = window.adminPortalSubMenu;
    if(!menuName) {
      setMenuByPath(leftNavObject);
    }
    if(!submenuName) {
      setSubmenuByPath(leftNavObject);
    }
  }

  useEffect(() => {

    if(leftNav.length === 0){
      // Now load left nav items from server. Use version cached in
      // sessionState while we wait to avoid "disappearing left nav syndrome."
      let sessionLeftNav = sessionStorage.getItem("AdminPortalLeftNav");
      if (sessionLeftNav && sessionLeftNav.length > 0) {
        const adminPortalLeftNav = JSON.parse(sessionLeftNav);
        initLeftNav(adminPortalLeftNav);
      }
      else {
        getJsonFromApi(`/adminportalleftnavitems`).then(
          (result) => {
            sessionStorage.setItem("AdminPortalLeftNav", JSON.stringify(result));
            initLeftNav(result);
          },
          (error) => {
            setError(error);
          }
        );
      }
    }
  }, [leftNav, submenu]);

  if (error) {
    return <div>{error.toString()}</div>;
  }

  const leftNavMarkup = leftNav.map((item, key) => (
    <LeftNavMenu
      item={item}
      key={key}
      insideRouter={insideRouter}
      isActive={item.label === menu}
      submenuName={submenu}
    />
  ));
  return (
    <React.Fragment>
      {/* BEGIN SIDEBAR */}
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n    .CustomDropdownCss {\n        left: 225px;\n        top: 0%;\n        background-color: #f2f3f4;\n        width: 240px;\n        padding-top: 0px !important;\n        padding-bottom: 10px;\n        border: 0px;\n    }\n\n        .CustomDropdownCss li {\n            color: #1676ba;\n        }\n\n        .CustomDropdownCss .divider {\n            margin-left: 15px;\n            margin-bottom: 2px;\n            margin-top: 3px;\n            margin-right: 15px;\n            width: 140px;\n        }\n\n        .CustomDropdownCss li > span {\n            padding-left: 15px;\n            display: inline-block;\n            padding-top: 8px;\n            color: #989898;\n        }\n\n        .CustomDropdownCss li > a {\n            padding-top: 0px;\n            padding-bottom: 0px;\n            color: #1676ba;\n            font-size: 11px;\n        }\n\n            .CustomDropdownCss li > a:hover {\n                color: #13629a;\n            }\n\n            .CustomDropdownCss li > a span {\n                display: list-item;\n                list-style-type: disc;\n                list-style-position: inside;\n                padding-left: 16px;\n            }\n\n    .dropdown.open .dropdown-toggle .selectedArrow {\n        background-image: url("/images/sidebar-menu-arrow.png");\n        display: block;\n        float: right;\n        height: 25px;\n        position: absolute;\n        right: 0;\n        top: 4px;\n        width: 8px;\n    }\n\n    #toast-container > div {\n    }\n\n    .build-css {\n        color: white;\n        margin-bottom: 20px;\n        font-size: 12px;\n    }\n\n    .build-cssli {\n        text-align: center;\n    }\n\n\n\n        .build-cssli span {\n            color: white;\n            margin-bottom: 20px;\n            font-size: 13px;\n        }\n',
        }}
      />
      <div className="page-sidebar-wrapper">
        <div className="page-sidebar navbar-collapse collapse">
          {/* BEGIN SIDEBAR MENU */}
          <ul
            className="page-sidebar-menu"
            data-keep-expanded="false"
            data-auto-scroll="true"
            data-slide-speed={200}
          >
            <li className="sidebar-toggler-wrapper">
              {/* BEGIN SIDEBAR TOGGLER BUTTON */}
              <div
                role="button"
                aria-label="Toggle Sidebar"
                className="sidebar-toggler hidden-phone"
              ></div>
              {/* BEGIN SIDEBAR TOGGLER BUTTON */}
            </li>
            <li className="sidebar-search-wrapper">
              {/* BEGIN RESPONSIVE QUICK SEARCH FORM */}
              <form className="sidebar-search" id="searchForm">
                <a className="remove">
                  <i className="fa fa-close" />
                </a>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Search..."
                    className="form-control"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        window.displayInfoMessage(
                          "This feature is currently under development. Please check back again soon!"
                        );
                      }
                    }}
                  />
                  <span className="input-group-btn">
                    <a className="btn submit">
                      <i className="fa fa-search" />
                    </a>
                  </span>
                </div>
              </form>
              {/* END RESPONSIVE QUICK SEARCH FORM */}
            </li>
            {leftNavMarkup}
            <li>
              <span style={{ display: "block", height: "432px" }}></span>
            </li>
          </ul>
          {/* END SIDEBAR MENU */}
        </div>
        <input
          id="viewDashboard"
          name="viewDashboard"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewDistricts"
          name="viewDistricts"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewSchools"
          name="viewSchools"
          type="hidden"
          defaultValue="True"
        />
        <input id="viewPOS" name="viewPOS" type="hidden" defaultValue="True" />
        <input
          id="viewUsers"
          name="viewUsers"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewUserRoles"
          name="viewUserRoles"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewCustomers"
          name="viewCustomers"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewHomerooms"
          name="viewHomerooms"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewGrades"
          name="viewGrades"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewActivity"
          name="viewActivity"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="AllowNewPayments"
          name="AllowNewPayments"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="AllowRefunding"
          name="AllowRefunding"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="AllowAccountAdjustments"
          name="AllowAccountAdjustments"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewCategoryTypes"
          name="viewCategoryTypes"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewCategories"
          name="viewCategories"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewMenu"
          name="viewMenu"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="ViewCustomerReports"
          name="ViewCustomerReports"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="ViewFinancialReports"
          name="ViewFinancialReports"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewParent"
          name="viewParent"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewMSAAlert"
          name="viewMSAAlert"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewMassSchoolAssignment"
          name="viewMassSchoolAssignment"
          type="hidden"
          defaultValue="True"
        />
        <input
          id="viewApplications"
          name="viewApplications"
          type="hidden"
          defaultValue="True"
        />
      </div>
      {/* END SIDEBAR */}
      
    </React.Fragment>
  );
}
